// OperatorPicker.jsx — operator dropdown filtered by field type, with help popover per option
import React from 'react';
import Select, { components } from 'react-select';
import { operatorsForField, OPERATORS } from '../helpers/fieldCatalog.js';
import HelpPopover from './HelpPopover.jsx';

const OptionWithHelp = (props) => {
  const op = OPERATORS[props.data.value];
  return (
    <components.Option {...props}>
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        {props.data.label}
        {op && (
          <HelpPopover
            description={op.description}
            example={op.example}
            placement="right"
          />
        )}
      </span>
    </components.Option>
  );
};

const OperatorPicker = ({ fieldKey, value, onChange }) => {
  const opts = operatorsForField(fieldKey).map(o => ({ value: o.value, label: o.label }));
  const selected = value
    ? { value, label: OPERATORS[value]?.label || value }
    : null;

  return (
    <Select
      value={selected}
      onChange={(opt) => onChange(opt ? opt.value : null)}
      options={opts}
      placeholder="Operator"
      isDisabled={!fieldKey}
      classNamePrefix="rs"
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      components={{ Option: OptionWithHelp }}
    />
  );
};

export default OperatorPicker;
